<template>
    <div id="contenedor-main-listado">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop :listadoAuditoriaContratos="listadoAuditoriaContratos"></desktop>
        </template>
        <template
            v-else>
            <desktop :listadoAuditoriaContratos="listadoAuditoriaContratos"></desktop>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListado',
  props: {
    listadoAuditoriaContratos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
